module.exports = __webpack_public_path__ + "img/Waaltastisch.da555a57.jpg";